import { getSizedImageUrl } from '../../utils/image'

const getSizedImage = (url: string, size: string): string => getSizedImageUrl(url, size)

export default getSizedImage